export default "__VITE_PUBLIC_ASSET__3f356df6__"